// TableReingresoSerie.tsx

import { CustomAutocompleteArrString, CustomTextArea } from "@/shared/components/ui";
import { ReingresoSerie } from "../../types";
import { gridSizeMdLg1, gridSizeMdLg12, useTableFilter, useTableServerSideFiltering } from "@/shared";
import { useFetchGetReingresoSerie, useFetchPostMarcarReingreso } from "@/shared/actions/contabilidad/reingreso-serie.actions";
import { useTableColumnsReingresoSerie } from "../../hooks";
import {
  Box, Button, Grid, IconButton,
  Typography,
  Alert
} from "@mui/material";
import {
  CheckCircleOutlineOutlined,
  HighlightOff,
  Refresh,
} from "@mui/icons-material";
import { MaterialReactTable, MRT_RowSelectionState, MRT_SelectCheckbox, useMaterialReactTable } from "material-react-table";
import { useState } from "react";
import ModalInformacionReingresoSerie from "../modal-informacion-reingreso-serie/ModalInformacionReingresoSerie";
import { ReingresoSerieChoice } from "../../utils/reingreso-serie.choice";
import { ScrollableDialogProps } from "@/shared/components/ui/Dialogs";
import { useFetchMotivos } from "@/shared/actions/erp";
import { useForm } from "react-hook-form";
import { toast } from "react-toastify";

type TableReingresoSerieProps = {
  estado: ReingresoSerieChoice
}

export default function TableReingresoSerie({ estado }: TableReingresoSerieProps) {

  const [rowSelection, setRowSelection] = useState<MRT_RowSelectionState>({});
  const [confirmDialogOpen, setConfirmDialogOpen] = useState(false);
  const [estadoSeleccionado, setEstadoSeleccionado] = useState<ReingresoSerieChoice | null>(null);
  // form
  const form = useForm<any>({

  });

  // hook
  const {
    pagination,
    setPagination
  } = useTableFilter();

  const {
    pageIndex,
    pageSize
  } = pagination;

  const {
    filterObject,
    columnFilters,
    setColumnFilters
  } = useTableServerSideFiltering();

  const {
    columns
  } = useTableColumnsReingresoSerie({
    estado: estado
  })

  // fetch

  const { data: motivos } = useFetchMotivos({
    modulo: 'REINGRESO_SERIES'
  });

  const {
    isLoading,
    data,
    isRefetching,
    refetch: refetchReingresoSerie
  } = useFetchGetReingresoSerie({
    params: {
      page: pageIndex + 1,
      page_size: pageSize,
      estado,
      ...filterObject,
      filterByState: false
    }
  });

  const {
    mutateAsync: mutateMarcarReingreso
  } = useFetchPostMarcarReingreso();

  // handle

  const handleModal = async (estado: ReingresoSerieChoice) => {
    setEstadoSeleccionado(estado);
    setConfirmDialogOpen(true);
  }

  const handleEnviarGestion = async () => {


    if (!form.getValues('motivo_receptor') || !form.getValues('observacion_receptor')) {
      toast.error('Debe completar los campos de motivo y observación');
      return;
    }

    const filasSeleccionadas: ReingresoSerie[] = table.getSelectedRowModel().rows.map((row: any) => row.original);

    const todasLasSeries = filasSeleccionadas.map(producto => {
      return {
        "id_solicitud_reingreso": producto.id_solicitud_reingreso,
        "serie": producto.serie.serie,
        "referencia_serie": producto.serie.referencia_serie,
        "estado": estadoSeleccionado,
        "motivo_receptor": form.getValues('motivo_receptor'),
        "observacion_receptor": form.getValues('observacion_receptor'),

      }
    }
    );

    const resp = await mutateMarcarReingreso(todasLasSeries as any)

    if (resp.code == 200) {
      refetchReingresoSerie()
      setConfirmDialogOpen(false)
    }

  }


  const table = useMaterialReactTable({
    columns,
    data: data?.data.data || [],
    enableGlobalFilter: false,
    enableRowSelection: estado === 'EN ESPERA',
    getRowId: (row: any) => String(row.id_solicitud_reingreso),
    onRowSelectionChange: setRowSelection,

    // server-side pagination
    manualPagination: true,
    onPaginationChange: setPagination,
    rowCount: data?.data?.count ?? 0,

    // server-side filtering
    manualFiltering: true,
    onColumnFiltersChange: setColumnFilters as any,
    state: {
      rowSelection,
      isLoading,
      showProgressBars: isRefetching,
      pagination,
      columnFilters: columnFilters as any,
    },
    positionToolbarAlertBanner: "head-overlay",

    initialState: { density: 'comfortable' },
    //enableColumnActions:true,
    //enableRowActions: true,
    //positionActionsColumn: 'first',
    //renderRowActions: ({row})=>{
    //  return (
    //    <IconButton>
    //      <ManageSearch />
    //    </IconButton>
    //  )
    //},

    // Personalización de la barra superior para el botón
    renderToolbarAlertBannerContent: ({ table, selectedAlert }) => (
      <Box
        sx={{
          display: 'flex',
          justifyContent: 'space-between', // Separa el grupo de la izquierda del botón de la derecha
          alignItems: 'center',
          width: '100%',
        }}
      >
        {/* Sub-contenedor para agrupar los elementos de la izquierda */}
        <Box
          sx={{
            display: 'flex',
            alignItems: 'center',
            gap: '1rem' // Controla la separación entre el checkbox y la alerta
          }}
        >
          <MRT_SelectCheckbox table={table} />
          {selectedAlert}
        </Box>

        <Box
          sx={{
            display: 'flex',
            alignItems: 'center',
            gap: '1rem'
          }}
        >

          <Button
            onClick={() => handleModal(ReingresoSerieChoice.RECHAZADO)}
            disabled={table.getSelectedRowModel().rows.length === 0}
            variant="text"
            startIcon={<HighlightOff />}
          >
            Rechazar
          </Button>

          <Button
            color="success"
            onClick={() => handleModal(ReingresoSerieChoice.APROBADO)}
            disabled={table.getSelectedRowModel().rows.length === 0}
            variant="contained"
            startIcon={<CheckCircleOutlineOutlined />}
          >
            Aprobar
          </Button>

        </Box>

      </Box>
    ),
  });

  return <>
    <Grid container spacing={3}
      justifyContent={'flex-end'}
      alignItems={'center'}
    >


      <Grid item {...gridSizeMdLg1}>

        <IconButton
          color="primary"
          onClick={() => {
            refetchReingresoSerie()
          }}
          sx={{
            bgcolor: 'primary.main',
            color: 'white',
            borderRadius: '50%',
            '&:hover': {
              bgcolor: 'primary.dark',
            },
          }}
        >
          <Refresh />
        </IconButton>
      </Grid>

      <Grid item xs={12}>
        <MaterialReactTable table={table} />
      </Grid>
    </Grid>;

    <ModalInformacionReingresoSerie />

    {
      confirmDialogOpen && (
        <ScrollableDialogProps
          open={confirmDialogOpen}
          onClose={() => setConfirmDialogOpen(false)}
          title="Confirmar"
          confirmTextBtn="Guardar"
          onConfirm={() => {
            handleEnviarGestion()
          }}

          contentNode={
            <Grid container spacing={3}>

              <Grid item {...gridSizeMdLg12}>
                <Alert severity={estadoSeleccionado === ReingresoSerieChoice.RECHAZADO ? "error" : "warning"}>
                  {
                    estadoSeleccionado === ReingresoSerieChoice.RECHAZADO ? (
                      <Typography>
                        ¿Está seguro de rechazar las series para reingreso? Esta acción no permitirá el ingreso de las series seleccionadas.
                      </Typography>
                    ) : (
                      <Typography>
                        ¿Está seguro de aprobar las series para reingreso? Esta acción confirmará el ingreso de las series seleccionadas.
                      </Typography>
                    )
                  }
                </Alert>
              </Grid>

              <CustomAutocompleteArrString
                label="Seleccionar Motivo"
                name="motivo_receptor"
                options={motivos?.data.data.map((m: any) => m.nombre) || []}
                control={form.control}
                defaultValue={form.getValues().motivo_receptor || ''}
                error={undefined}
                helperText={undefined}
                isLoadingData={false}
                size={gridSizeMdLg12}
              />

              {/* Campo de Observaciones */}


              <CustomTextArea
                type="none"
                typeOfEntry='observacion'
                name="observacion_receptor"
                control={form.control}
                label="Observación Adicional"
                required={false}
                maxRows={4}
                minRows={4}
                error={undefined}
                helperText={undefined}
              />

            </Grid>
          }
        />
      )
    }
  </>

}
